var servicenavInit = function (buttonObj, slideObj) {

    var slide = slideObj;

    slide
        .hide()

    buttonObj
        .attr({
            'aria-expanded': 'false'
        });

    buttonObj.off("click").on("click", function (evt) {

        var $this = $(this);

        if ($this.parent().has("ul").length) {

            evt.preventDefault();

            $this
                .toggleClass('active')
                .next(slide)
                .fadeToggle()
                .toggleClass('open');


            if ($this.hasClass('active')) {
                $this.attr({ 'aria-expanded': 'true' })
            } else {
                $this.attr({ 'aria-expanded': 'false' })
            }
            slide
                .not($this
                    .next())
                    .hide()

            //Scroll to button
            var devicewidth = $(window).width();
            var mobileheaderHeight = $('.m-header').height();
            if (devicewidth < 768) {
                var offset = mobileheaderHeight
            }
            else {
                var offset = 0
            }
            $("html, body").animate({
                scrollTop: $this.offset().top - offset
            }, 500);


            buttonObj
                .not($this)
                .removeClass('active');

            $this.next(slide);
        }
    });
}

